import packageJson from "/package.json";

export const client = {
  appName: 'Boostaminophen',
  platform: 'Web',
  market: 'Direct',
  language: 'EN',
  version: packageJson.version,
  firebaseID: localStorage.getItem('firebaseID')
};